
<div class="main-content">
      <div class="container-fluid">

            <div class="row">

                  <div class="card">

                        <div class="card-header card-header-icon">
                              <div class="card-icon"><i class="material-icons">pie_chart</i></div>
                              <h4 class="card-title">Resumen de tickets</h4>

                              <form [formGroup]='frmFiltrosGrfTickets' [ngClass]="'gral-filtros'">
                                    <div class="row justify-content-start">
                                          <div class="col-6 col-xs-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                                <mat-form-field>
                                                      <mat-select formControlName='aSolicitanteCtrl'
                                                            [(ngModel)]="idSolicitante"
                                                            (selectionChange)="solicitanteChange(true)"
                                                            selected="selected">
                                                            <mat-option *ngFor="let item of areas" [value]="item.id">
                                                                  {{item.area}}
                                                            </mat-option>
                                                      </mat-select>
                                                      <mat-label> Área solicitante </mat-label>
                                                </mat-form-field>
                                          </div>

                                          <div class="col-6 col-xs-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                                <mat-form-field>
                                                      <mat-select formControlName='aResolutoriaCtrl'
                                                            [(ngModel)]="idResolutora"
                                                            (selectionChange)="resolutoraChange(true)"
                                                            selected="selected">
                                                            <mat-option *ngFor="let item of areas" [value]="item.id">
                                                                  {{item.area}}
                                                            </mat-option>
                                                      </mat-select>
                                                      <mat-label> Área resolutora </mat-label>
                                                </mat-form-field>
                                          </div>

                                          <div class="col-6 col-xs-6 col-sm-3 col-md-3 col-lg-3 col-xl-3">
                                                <mat-form-field>
                                                      <mat-select class='mat-select ng-tns-c4-24 ng-star-inserted'
                                                            placeholder="Prioridad" formControlName='prioridadCtrl'
                                                            (selectionChange)='prioridadChange(true)'
                                                            [(ngModel)]="prioridad">
                                                            <mat-option *ngFor='let pr of prioridades' [value]='pr'>
                                                                  {{pr}}
                                                            </mat-option>
                                                      </mat-select>
                                                </mat-form-field>
                                          </div>

                                          <div class="col-6 col-xs-6 col-sm-3 col-md-3 col-lg-3 col-xl-3  text-left">
                                                <div class='form-check form-check-radio'>
                                                      <button mat-mini-fab type='button' matTooltip='Limpiar filtros'
                                                            class='btn btn-default btn-round' (click)='clear()'
                                                            (keydown.enter)='clear()'>
                                                            <i class='material-icons'>clear</i>
                                                      </button>
                                                </div>
                                          </div>
                                    </div>
                              </form>
                        </div>

                        <div class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf='mostrarEstatus'>
                              <canvas id="grfTicketsPorEstatus"></canvas>
                              <div class='row justify-content-end' [ngClass]="'gral-datos'">
                                    <div class='col-12 col-sm-12 col-md-12 col-lg-12 text-right'>
                                          <span class='etiqueta'> Total tickets: &nbsp;</span>
                                          {{totalRegistros | number }}
                                          &nbsp;&nbsp;&nbsp;
                                          <span class='etiqueta'> Total resultados: &nbsp;</span>
                                          {{totalGrafica | number }}
                                    </div>
                              </div>
                        </div>

                        <div class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" *ngIf='!mostrarEstatus'>
                              <label> Sin datos para mostrar </label>
                        </div>

                  </div>

                  <div class="card">

                        <div class="card-header card-header-icon">
                              <div class="card-icon"><i class="material-icons">pie_chart</i></div>
                              <h4 class="card-title">Resumen de tickets por área </h4>

                              <form [formGroup]='frmFiltrosGrfTicketsSolicitante' [ngClass]="'gral-filtros'">
                                    <div class="row justify-content-start">
                                          <div class="col-6 col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                                <mat-form-field>
                                                      <mat-select class='mat-select ng-tns-c4-24 ng-star-inserted'
                                                            placeholder="Estatus" formControlName='estatusCtrl'
                                                            [(ngModel)]="estatus"
                                                            (selectionChange)='estatusChange(true)'>
                                                            <mat-option *ngFor='let est of estatusTickets'
                                                                  [value]='est'>
                                                                  {{est}}
                                                            </mat-option>
                                                      </mat-select>
                                                </mat-form-field>
                                          </div>

                                          <div class="col-6 col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-left">
                                                <div class='form-check form-check-radio'>
                                                      <button mat-mini-fab type='button' matTooltip='Limpiar filtros'
                                                            class='btn btn-default btn-round'
                                                            (click)='clearSolicitante()'
                                                            (keydown.enter)='clearSolicitante()'>
                                                            <i class='material-icons'>clear</i>
                                                      </button>
                                                </div>
                                          </div>

                                    </div>
                              </form>
                        </div>

                        <div class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                              *ngIf='mostrarSolicitante'>
                              <canvas id="grfTicketsAreaSolicitante"></canvas>

                              <div class='row justify-content-start' [ngClass]="'gral-detalle'"
                                    *ngIf='mostrarDetalleLista'>
                                    <label class='form-check'>
                                          <input class='form-check-input' type='checkbox' [(ngModel)]='mostrarDetalle'>
                                          <span class='form-check-sign'>
                                                <span class='check'></span>
                                          </span>
                                          Mostrar detalle
                                    </label>
                              </div>

                              <div class="row justify-content-start" [ngClass]="'gral-lista'" *ngIf='mostrarDetalle'>
                                    <div *ngFor='let area of detallesAreas'
                                          class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                          <label class='lista'>
                                                <i class='material-icons'
                                                      [ngStyle]="{'color': area.color }">bookmark</i>
                                                {{ area.valor }}
                                          </label>
                                    </div>

                              </div>
                        </div>

                        <div class="col-12 col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12"
                              *ngIf='!mostrarSolicitante'>
                              <label> Sin datos para mostrar </label>
                        </div>

                  </div>
            </div>


      </div>
</div>

<div class='row justify-content-end' [ngClass]="'flotante'">
      <div class="col-6 col-xs-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-right">

            <button mat-button class="btn btn-success" (click)="generarRptSolicitante()">
                  <!-- For IE9 or below. -->

                  <i class="material-icons">
                        cloud_download
                  </i>Descargar</button>


            <!---->
            <a class="download-zip-link" #downloadRptGrfSolicitante aria-label="Descargar reporte"></a>
      </div>
</div>